import NewPage from "./NewPage";

export const CheckIns = {
  Create: NewPage,
};
